@if (isSelectorVisible) {
  <div class="layout-preset-selector_overlay" (click)="dismissSelector()"></div>
  <div class="layout-preset-selector_window">
    <!-- HEADER -->
    <div class="layout-preset-selector_window-header">
      <div class="layout-preset-selector_window-header-title" textHiding>
        <span>{{'components.layout-preset-selector.title' | l10n}}</span>
      </div>
      <svg class="layout-preset-selector_window-header-close" (click)="dismissSelector()">
        <use xlink:href="#close"></use>
      </svg>
    </div>
    <!-- BODY -->
    <div class="layout-preset-selector_window-body">
      <div class="layout-preset-selector_presets">
        <div class="layout-preset-selector_presets-tabs">
          @for (layoutPresetCategory of layoutPresetCategories; track layoutPresetCategory) {
            <div class="layout-preset-selector_presets-category"
              (click)="setLayoutPresetCategory(layoutPresetCategory)"
              [class.-active]="layoutPresetCategory === currentLayoutPresetCategory">
            {{layoutPresetCategoryDict[layoutPresetCategory] | l10n}}</div>
          }
        </div>
        <div class="layout-preset-selector_presets-body">
          @for (layoutPreset of layoutPresets | layoutPresetFilterPipe:currentLayoutPresetCategory; track layoutPreset) {
            <div class="layout-preset-selector_preset"
              (click)="setLayoutPreset(layoutPreset)">
              <img class="layout-preset-selector_preset-image" [src]="layoutPreset.image" alt="{{layoutPreset.name}}">
              <div class="layout-preset-selector_preset-name">{{layoutPreset.name}}</div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
